import React from 'react'

import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import { InvoicesList } from './InvoicesList'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

function InvoicesPage() {
    const {t} = useTranslation()
    const [searchParams,] = useSearchParams()

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/invoices/add'}>
                <button className="amani-primary">{t('create_invoice')}</button>
            </Link>}>{t('invoicing')}</AppTitle>
            {searchParams.get('new') ? <div className="alert alert-success">{t('invoice_added_success')}</div> : null}

            <InvoicesList/>
        </AppLayout>
    )
}

export default InvoicesPage
